'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { BLUR_PLACEHOLDER } from '@/lib/componentutills';
type Slide = {
  title: string;
  image?: string;
  slug?: string;
  storyTemplate?: string;
};
type SliderProps = {
  slides?: Slide[];
  intervalMs?: number;
  width?: number | string;
  ratio?: number | string;
  showControls?: boolean;
  className?: string;
};
export default function Slider(t0) {
  const $ = _c(26);
  const {
    slides,
    width: t1,
    ratio: t2,
    className
  } = t0;
  const width = t1 === undefined ? "100%" : t1;
  const ratio = t2 === undefined ? "183 / 280" : t2;
  const firstSlide = slides?.[0];
  if (!firstSlide) {
    return null;
  }
  let t3;
  if ($[0] !== firstSlide.slug) {
    t3 = () => {
      if (!firstSlide.slug) {
        return;
      }
      window.open(`/${firstSlide.slug}`, "_blank");
    };
    $[0] = firstSlide.slug;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const handleClick = t3;
  let t4;
  if ($[2] !== ratio || $[3] !== width) {
    t4 = {
      position: "relative",
      overflow: "hidden",
      width,
      aspectRatio: ratio
    };
    $[2] = ratio;
    $[3] = width;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = firstSlide.slug ? "pointer" : "default";
  let t6;
  if ($[5] !== t5) {
    t6 = {
      position: "absolute",
      inset: 0,
      cursor: t5
    };
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = firstSlide.image || "https://media.dinamani.com/dinamani/2026-02-27/pm7gpn7o/dummy.png";
  const t8 = typeof width === "number" ? `${width}px` : "(max-width: 768px) 100vw, 400px";
  let t9;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      objectFit: "cover"
    };
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] !== firstSlide.title || $[9] !== t7 || $[10] !== t8) {
    t10 = <Image src={t7} alt={firstSlide.title} fill={true} priority={true} sizes={t8} style={t9} placeholder="blur" blurDataURL={BLUR_PLACEHOLDER} />;
    $[8] = firstSlide.title;
    $[9] = t7;
    $[10] = t8;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  let t12;
  let t13;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div style={{
      position: "absolute",
      inset: 0,
      background: "linear-gradient(to top, rgba(0,0,0,0.7), rgba(0,0,0,0.25) 50%, transparent)",
      pointerEvents: "none"
    }} />;
    t12 = {
      position: "absolute",
      left: 12,
      right: 12,
      bottom: 12,
      userSelect: "none",
      pointerEvents: "none"
    };
    t13 = {
      color: "white",
      fontWeight: 600,
      fontSize: 14,
      lineHeight: "18px",
      textShadow: "0 1px 1px rgba(0,0,0,0.8)",
      display: "-webkit-box",
      WebkitLineClamp: 3,
      WebkitBoxOrient: "vertical",
      overflow: "hidden"
    };
    $[12] = t11;
    $[13] = t12;
    $[14] = t13;
  } else {
    t11 = $[12];
    t12 = $[13];
    t13 = $[14];
  }
  let t14;
  if ($[15] !== firstSlide.title) {
    t14 = <div style={t12}><p style={t13}>{firstSlide.title}</p></div>;
    $[15] = firstSlide.title;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  let t15;
  if ($[17] !== handleClick || $[18] !== t10 || $[19] !== t14 || $[20] !== t6) {
    t15 = <div style={t6} onClick={handleClick}>{t10}{t11}{t14}</div>;
    $[17] = handleClick;
    $[18] = t10;
    $[19] = t14;
    $[20] = t6;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== className || $[23] !== t15 || $[24] !== t4) {
    t16 = <div className={className} style={t4}>{t15}</div>;
    $[22] = className;
    $[23] = t15;
    $[24] = t4;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  return t16;
}